import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, SummaryItem } from '../../../../tms-shared';
import { UserDetails } from '../../models';
import { UserService } from '../../services';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})
export class UserComponent extends BaseComponent implements OnInit {
  readonly detailsHeader = $localize`Details`;
  readonly rolesHeader = $localize`Roles`;
  readonly chartsHeader = $localize`Charts`;
  readonly printersHeader = $localize`Printers`;

  model$: Observable<UserDetails>;
  private id: string;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  summaryTopItems(model: UserDetails): SummaryItem[] {
    return [
      { label: $localize`Name`, value: `${model.firstName} ${model.lastName}` },
      { label: $localize`Username`, value: model.username },
    ];
  }

  getModel(): void {
    if (this.id) {
      this.model$ = this.userService.edit(this.id).pipe(takeUntil(this.destroy$));
    }
  }
}
